module.exports = __webpack_public_path__ + "img/chair2.e692cc05.jpg";